import React, {useEffect, useState} from 'react';
import { Table } from 'antd';
import {Redirect} from "react-router-dom";


const StatisticsTable = ({imba_id, dataSource, columns}) => {
    const[loading, setLoading] = useState(true)
    const [choose, setChoose] = useState(false)
    const [total, setTotal] = useState(0);
    const [per, setPer] = useState(10);

    useEffect(() => {
        //setLoading(false)
        if (dataSource)
            setLoading(false);
    }, [dataSource])
    return choose ? (
        <Redirect to = {{ pathname: `/${imba_id}/statistic/${choose}` }} />
    ) : (
        <Table columns={columns} pagination={false} dataSource={dataSource} loading={loading} rowClassName={'imbachat-table-row'}
        onRow={
            (record, index) => {
                return {
                    onClick: event => {
                        console.log(event.target)
                        console.log(record.id)
                        setChoose(record.id)
                        let ban_btn = ""
                        if (document.getElementById(`ban-${record.id}`))  ban_btn = document.getElementById(`ban-${record.id}`)
                        if (document.getElementById(`ban-${record.id}`) && !ban_btn.contains(event.target))
                        {
                            if(event.target.outerText != "Break" && event.target.outerText != "ban user" && event.target.outerText != "Delete user" && event.target.outerText != "Restore user" && !event.target.id.includes('rc_select') && !(event.target.outerText == "1h" || event.target.outerText == "30m" || event.target.outerText == "24h" || event.target.outerText == "1 week" || event.target.outerText == "forever") && event.target.outerText != "OK"){
                                setChoose(record.remote_user_id)
                            }
                        }
                    }
                }
            }
        }/>
    )
}
export default StatisticsTable;